import { computed, Directive, effect, inject, input } from '@angular/core';

import {
  SlackLinkDirective as PuSlackLinkDirective,
} from '@hglobal/common';
import { environment } from '@pt/environment';

export enum SlackLinkType {
  Channel = 'channel',
  User = 'user',
}

/**
 * Now uses signal inputs and an effect to propagate values to the inner directive.
 * Defaults for teamId/workspace are handled via computed fallbacks.
 */
@Directive({
  selector: '[puSlackLink]',
  standalone: true,
  hostDirectives: [
    {
      directive: PuSlackLinkDirective,
    },
  ],
})
export class SlackLinkDirective {
  puSlackLink = input.required<string>();
  linkType = input<SlackLinkType>(SlackLinkType.User);

  teamId = input<string | undefined>();
  workspace = input<string | undefined>();

  #effectiveTeamId = computed(() => this.teamId() ?? environment.slackTeamId);
  #effectiveWorkspace = computed(() => this.workspace() ?? environment.slackWorkspace);

  #innerDirective = inject(PuSlackLinkDirective);

  constructor() {
    effect(() => {
      if (!this.#innerDirective) return;

      this.#innerDirective.slackId = this.puSlackLink();
      this.#innerDirective.linkType = this.linkType();
      this.#innerDirective.teamId = this.#effectiveTeamId();
      this.#innerDirective.workspace = this.#effectiveWorkspace();
    });
  }
}
